import React from 'react'
import SvgMapper from "../../features/common/SvgMapper";

const OverviweTab = () => {
  return (
    <>
    <div className="bg-black rounded-lg aspect-video relative">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-white text-center">
                  {SvgMapper.play("w-16 h-16 mx-auto mb-4 opacity-50")}
                  <p className="text-lg">Interview Recording</p>
                  <p className="text-sm opacity-75">Duration: 28:45</p>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
                <div className="flex items-center justify-between text-white">
                  <div className="flex items-center space-x-4">
                    <button className="p-2 hover:bg-white/20 rounded-lg">
                      {SvgMapper.play("w-5 h-5")}
                    </button>
                    {SvgMapper.skipBack("w-5 h-5")}
                    {SvgMapper.skipForward("w-5 h-5")}
                    <span className="text-sm">00:00 / 28:45</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    {SvgMapper.volume2("w-5 h-5")}
                    <div className="w-20 h-1 bg-white/30 rounded-full">
                      <div className="w-3/4 h-full bg-white rounded-full"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="bg-blue-50 rounded-lg p-6">
                <h3 className="text-lg font-semibold text-blue-900 mb-4 flex items-center">
                  {SvgMapper.checkCircle("w-5 h-5 mr-2")}
                  AI Assessment Summary
                </h3>
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-blue-700">Overall Recommendation:</span>
                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      PASS
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-blue-700">Confidence Level:</span>
                    <span className="font-medium text-blue-900">High (87%)</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-blue-700">Interview Quality:</span>
                    <span className="font-medium text-blue-900">Good</span>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Key Strengths
                </h3>
                <ul className="space-y-2">
                  <li className="flex items-start space-x-2">
                    {SvgMapper.checkCircle("w-4 h-4 text-green-500 mt-0.5")}
                    <span className="text-sm text-gray-700">
                      Strong data-driven approach with specific metrics
                    </span>
                  </li>
                  <li className="flex items-start space-x-2">
                    {SvgMapper.checkCircle("w-4 h-4 text-green-500 mt-0.5")}
                    <span className="text-sm text-gray-700">
                      Excellent technical knowledge of Meta advertising
                    </span>
                  </li>
                  <li className="flex items-start space-x-2">
                    {SvgMapper.checkCircle("w-4 h-4 text-green-500 mt-0.5")}
                    <span className="text-sm text-gray-700">
                      Clear communication and professional demeanor
                    </span>
                  </li>
                </ul>
              </div>
            </div>
  </>
  )
}

export default OverviweTab
